import type { FC } from 'react'
import styled from 'styled-components'

interface Props {
  label: string
}

const Label = styled.h5`
  font-family: Montserrat;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.21px;
  margin: 0;
`

const Body = styled.div`
  margin-top: 10px;
`

const Detail: FC<Props> = ({ label, children }) => (
  <div>
    <Label>{label}</Label>
    <Body>{children}</Body>
  </div>
)

export default Detail
